// extracted by mini-css-extract-plugin
export var animationContainer = "_jp-0";
export var footer = "_jp-1";
export var gray = "_jp-2";
export var lineItem = "_jp-3";
export var lineItemImage = "_jp-4";
export var lineItemInfo = "_jp-5";
export var lineItemText = "_jp-6";
export var lineItems = "_jp-7";
export var modalContent = "_jp-8";
export var options = "_jp-9";
export var orderName = "_jp-a";
export var refundAmount = "_jp-b";